import { render } from "./MainList.vue?vue&type=template&id=0ee66ec5"
import script from "./MainList.vue?vue&type=script&lang=js"
export * from "./MainList.vue?vue&type=script&lang=js"

import "./MainList.vue?vue&type=style&index=0&id=0ee66ec5&lang=css"

import exportComponent from "/Users/carolinadoerflinger/SmileAndLearn/acttiv-landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__